import { render, staticRenderFns } from "./KdsColumn.vue?vue&type=template&id=7f4dd43c&scoped=true"
import script from "./KdsColumn.vue?vue&type=script&lang=js"
export * from "./KdsColumn.vue?vue&type=script&lang=js"
import style0 from "./KdsColumn.vue?vue&type=style&index=0&id=7f4dd43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4dd43c",
  null
  
)

export default component.exports